import { Injectable, OnDestroy } from "@angular/core";
import { loadKey } from "./models/loadKey";
import { _BaseLoadingService } from "./_base-loading.service";

@Injectable({
    providedIn: 'root'
})
export class LoadingHeaderService
    extends _BaseLoadingService
{

    constructor() {
        super(
            loadKey.loadingHeader
        )
    }

    add(): void {
        super._add();
    }

    addCount(value: number): void {
        super._addCount(value);
    }

    clear(): void {
        super._clear();
    }

    remove(): void {
        super._remove();
    }

    removeCount(value: number): void {
        super._removeCount(value);
    }

    reset(): void {
        super._clear();
    }
}